// src/pages/About/About.js

import React from "react";
import "./About.css";

import doctor from "../../assests/doctor.jpeg";

import {
  FaGraduationCap,
  FaAward,
  FaLeaf,
  FaHeartbeat
} from "react-icons/fa";

function About() {

  const handleBookAppointment = () => {
    window.location.href = "/appointment";
  };

  return (
    <section className="about-page">

      {/* HERO */}
      <div className="about-hero">

        <p className="about-tag">
          ABOUT ROOTLY
        </p>

        <h1>
          Meet Your Doctor
        </h1>

        <p className="about-subtitle">
          Expert holistic care focused on healing from the root up.
        </p>

      </div>

      {/* MAIN */}
      <div className="about-container">

        {/* LEFT */}
        <div className="about-left">

          <img
            src={doctor}
            alt="Dr Lalitha Maddineni"
            className="doctor-image"
          />

        </div>

        {/* RIGHT */}
        <div className="about-right">

          <h2>
            Dr. Lalitha Maddineni
          </h2>

          <p className="doctor-degree">
            BHMS, MD (HOM), M.Sc (Psychology), Certified Nutritionist
          </p>

          <p className="doctor-desc">
            Dr. Lalitha Maddineni is a dedicated homoeopathic physician who
            believes true healing begins by identifying and treating the root
            cause of illness. Her patient-first approach combines deep clinical
            understanding with natural medicine to provide safe and lasting
            wellness solutions.
          </p>

          <p className="doctor-desc">
            With advanced academic qualifications in Homoeopathy, Psychology,
            and Nutrition, she offers complete holistic care that supports both
            physical and emotional wellbeing. Every treatment plan is carefully
            personalized based on the patient’s symptoms, lifestyle, and goals.
          </p>

          <p className="doctor-desc">
            Over the past 5+ years, she has successfully guided patients with
            skin conditions, thyroid disorders, PCOD, fertility concerns,
            allergies, respiratory issues, digestive disorders, and chronic
            recurring health complaints.
          </p>

          <p className="doctor-desc">
            She is also passionate about preventive care through personalized
            diet plans, mental health counseling, and parenting guidance,
            helping individuals and families build healthier lives naturally.
          </p>

          <div className="info-grid">

            <div className="info-card">
              <FaGraduationCap />
              <h3>Education</h3>
              <p>BHMS - Dr. NTR University</p>
              <p>MD(HOM) - KNR University</p>
              <p>M.Sc Psychology - Andhra University</p>
              <p>Nutrition - BHU</p>
            </div>

            <div className="info-card">
              <FaAward />
              <h3>Experience</h3>
              <p>5+ Years of holistic clinical experience.</p>
            </div>

            <div className="info-card">
              <FaLeaf />
              <h3>Special Services</h3>
              <p>Diet Plans</p>
              <p>Mental Health Counseling</p>
              <p>Parenting Assistance</p>
            </div>

            <div className="info-card">
              <FaHeartbeat />
              <h3>Treatments</h3>
              <p>Skin, PCOD, Thyroid, Allergy, Fertility & Child Care.</p>
            </div>

          </div>

          {/* BOOK BUTTON */}
          <div className="about-btn-wrap">

            <button
              className="about-book-btn"
              onClick={handleBookAppointment}
            >
              Book Appointment
            </button>

          </div>

        </div>

      </div>

    </section>
  );
}

export default About;